export enum StaticPagesEnum {
  ABOUT = 'om-varden',
  ABOUT_CONTACT = 'kontakt',
  ABOUT_MEDARBETARE = 'medarbetare',
  TERMS = 'villkor',
  PRIVACY = 'integritetspolicy',
  COMMENTPOLICY = 'bloggkommentarer-policy',
  FOR_CAREPROVIDERS = 'blikund',
  REVIEW = 'omdomenpolicy',
  HOME = 'homepage',
  GUIDES = 'vara-guider',
  FOOTER_CONTENT = 'footer-content',
}

export enum GuideItemsEnum {
  FORNYA_RECEPT = 'fornya-recept',
}
